(function($) {

  function setContentBlockPadding() {
    var w_width = $(window).width();
    var container_width = $('.container').outerWidth();

    if ($(window).width() > 992) {
      padding = ((w_width - container_width) / 2);
      //set padding for members area grid
      $('#membersLayout .members-sidebar').css('padding-left',padding+15);
      $('#membersLayout .members-content').css('padding-right',padding+15);
    } else {
      padding = 0;
    }

    $('.content-sections .block .content.right').css('padding-right',padding);
    $('.content-sections .block .content.left').css('padding-left',padding);
    //set padding for news intro box
    $('#latestNews .intro-box').css('padding-left',padding);


    //set splash container on responsive
    splash_container_width = $('#splashWrapper>.top>.container').width();
    if ($(window).width() < 992 && $(window).width() > 767) {
      splash_padding = ((w_width - splash_container_width) / 2);
    } else {
      splash_padding = 0;
    }
    $('#splashWrapper>.optionsWrapper .option>.inner').css('padding-left',splash_padding);
    $('#splashWrapper>.optionsWrapper .option>.inner').css('padding-right',splash_padding);
  }

   function clearEnquiryForm() {
     $('#enquiryOverlay form input').not(':hidden').removeClass('wpcf7-not-valid');
     $('#enquiryOverlay form input').not(':hidden').attr('aria-invalid','false');
     $('#enquiryOverlay form input').not(':hidden').val('');
     $('#enquiryOverlay form textarea').removeClass('wpcf7-not-valid');
     $('#enquiryOverlay form textarea').attr('aria-invalid','false');
     $('#enquiryOverlay form textarea').val('');
     $('.wpcf7-not-valid-tip').remove();
     $('.wpcf7-response-output').removeClass('wpcf7-validation-errors');
     $('.wpcf7-response-output').css('display','none');
     $('.wpcf7-response-output').html('');
   }

   //-------------------------------------------
   //Handle User Login Click
   //-------------------------------------------
   function handleLoginClick() {
     $('form[name="userLogin"]').on('submit',function(e) {
       $('#loginBox .wrp .loaderWrapper #loginSubmitButton').addClass('focused');
       $('#loginBox .wrp .loaderWrapper .loader').show();
       $.ajax({
         url: ajaxurl,
         type: 'POST',
         dataType: 'json',
         data: {
           action: 'check_form_login',
           user_name: $('#loginBox .wrp input[name="user_name"]').val(),
           user_pass: $('#loginBox .wrp input[name="user_pass"]').val(),
           security:  $('#loginBox .wrp input[name="security"]').val()
         }
       }).done(function(data) {
         if (data.loggedin === false) {
           $('#loginResponse').addClass('error').html(data.message).fadeIn();
         } else {
           // set to green
           $('#loginBox').addClass('success');
           $('#loginResponse').removeClass('error').html(data.message).fadeIn();
           //wait for 2 seconds before redirect
           setTimeout(function() {
             window.location.href = $('#loginBox .wrp input[name="redirect_to"]').val();
           },2000);
         }
       }).always(function() {
         $('#loginBox .wrp .loaderWrapper #loginSubmitButton').removeClass('focused');
         $('#loginBox .wrp .loaderWrapper .loader').hide();
       });
       e.preventDefault();
     });
   }

   $(document).ready(function(){

     setContentBlockPadding();

     // Set login bar width
     var page_width = $('.main').width();
     $('#loginBar').width(page_width);

     //-------------------------------------------
     //Create custom dropdown in members area menu
     //-------------------------------------------
     $('.members-sidebar .members-menu').tkDropdown({
       id: 'members-dropdown',
       iconText: '<span class="icon-chevron"></span>',
       toggleMode: 'custom',
       activeClass: 'current-menu-item'
     });

     //-------------------------------------------
     //Handle Home loginbar close
     //-------------------------------------------
      $('#closeLoginBar').click(function(){
        $('#loginBar').fadeOut();
      });

      //-------------------------------------------
      //Initialize Lightbox for Video Popup
      //-------------------------------------------
      $('.popup-video').magnificPopup({
         type: 'iframe',
         mainClass: 'mfp-fade',
         removalDelay: 160,
         preloader: false,
         fixedContentPos: false,
         closeMarkup: '<span class="mfp-close icon-close"></span>'
      });

      //-------------------------------------------
      //Initialize Hero Carousel
      //-------------------------------------------
      $('#heroSlider').on('initialized.owl.carousel', function(event) {
        $('#heroSliderWrapper .heroBanner.image .overlay.animated').addClass('fadeInLeft');
        $('#heroSliderWrapper .heroBanner.image .inner.animated').addClass('fadeIn');
      }).owlCarousel({
         loop:true,
         nav:false,
         dots:false,
         autoplay:true,
         autoplaySpeed: 700,
         items:1,
         margin:0
      });

      //-------------------------------------------
      //Initialize Home News Carousel
      //-------------------------------------------
      $('#newsCarousel').owlCarousel({
         loop:true,
         dots:false,
         autoplay:true,
         autoplaySpeed: 700,
         items:1,
         autoWidth:true,
         margin:0,
         responsive: {
           0: {
             nav:true,
             navText:['','']
           },
           992: {
             nav:false
           }
         }
      });







      // Animations
      // $('#reflect').waypoint(function() {
      //   console.log('test');
      //   $('#reflect .left').addClass('animated');
      //   $('#reflect .right').addClass('animated');
      // }, { offset: '50%' });

      $('.animated').css('opacity', 0);

      $('.body-wrapper').scroll(function(event) {
        var scroll = $(window).scrollTop();
        var scroll_trigger = 500;
        var reflect = $('#reflect');
        var empower = $('#empower');
        var improve = $('#improve');
        var sharing = $('#sharing');
        var self_eval = $('#self');
        var data = $('#data');
        var repeat_layouts_video = $('#repeatLayouts .video');
        
        if( reflect.length && scroll > ( reflect.offset().top - scroll_trigger ) ) {
          $('#reflect .col.flex-first').addClass('fadeInLeft');
          $('#reflect .col.flex-last').addClass('fadeInRight');
          
          setTimeout(function(){ reflect.addClass('animate'); }, 1000);
        }

        if( empower.length && scroll > ( empower.offset().top - scroll_trigger ) ) {
          $('#empower .col.flex-first').addClass('fadeInLeft');
          $('#empower .col.flex-last').addClass('fadeInRight');
          
          setTimeout(function(){ empower.addClass('animate'); }, 1000);
        }

        if( improve.length && scroll > ( improve.offset().top - scroll_trigger ) ) {
          $('#improve .col.flex-first').addClass('fadeInLeft');
          $('#improve .col.flex-last').addClass('fadeInRight');
          
          setTimeout(function(){ improve.addClass('animate'); }, 1000);
        }

        if( sharing.length && scroll > ( sharing.offset().top - scroll_trigger ) ) {
          $('#sharing .col.flex-first').addClass('fadeInLeft');
          $('#sharing .col.flex-last').addClass('fadeInRight');
          
          setTimeout(function(){ sharing.addClass('animate'); }, 1000);
        }

        if( self_eval.length && scroll > ( self_eval.offset().top - scroll_trigger ) ) {
          $('#self .col.flex-first').addClass('fadeInLeft');
          $('#self .col.flex-last').addClass('fadeInRight');

          setTimeout(function(){ $('#bulb_off').fadeOut('fast'); }, 2500);
        }

        if( data.length && scroll > ( data.offset().top - scroll_trigger ) ) {
          $('#data .col.flex-first').addClass('fadeInLeft');
          $('#data .col.flex-last').addClass('fadeInRight');
          
          setTimeout(function(){ data.addClass('animate'); }, 1000);
        }

        if( repeat_layouts_video && scroll > ( repeat_layouts_video.offset().top + 250 ) ) {
          // setTimeout(function(){
            repeat_layouts_video.find('.learnMoreTooltip').children('.text').css('opacity', 1).addClass('type');
          // }, 1000);
        }

      });








      //-------------------------------------------
      //Handle Enquiry Form & Modal
      //-------------------------------------------
      $('#repeatLayouts .block.prices .priceButton').click(function(){
        //Reset form elements
        clearEnquiryForm();

        var id = $(this).attr('data-id');
        var school = $('#repeatLayouts .block.prices .priceBox[data-id="'+id+'"]').closest('.container').children('.block-title').text();
        var title = $('#repeatLayouts .block.prices .priceBox[data-id="'+id+'"] .title').text();
        var subject_value = 'Website Enquiry ('+school+': '+title+')';
        var button_label = $('#sendEnquiryButton').val();
        $('#enquiryOverlay input[name="enquiry_subject"]').val(subject_value);
        $('#enquiryOverlay .inner #submitEnquiry .text').html(button_label);
        $('#enquiryOverlay').fadeIn();
      });

      $('#enquiryOverlay .close').click(function(){
        $('#enquiryOverlay input[name="enquiry_subject"]').val('');
        $('#enquiryOverlay').fadeOut();
      });

      $('#enquiryOverlay .inner #submitEnquiry').click(function(){
        $('#sendEnquiryButton').trigger('click');
      });


      //-----------------------------------------------
      //Remove next / prev button from post navigation
      //-----------------------------------------------
      $('.post-navigation li').each(function() {
        var elem = $(this).children('a');
        if (elem.hasClass('prev') || elem.hasClass('next')) {
          elem.parent('li').remove();
        }
      });


      //-------------------------------------------
      //Handle Contact Form
      //-------------------------------------------
      var contact_button_label = $('#contactSubmit').val();
      $('#submitEnquiryContact .text').html(contact_button_label);

      $('#submitEnquiryContact').click(function(){
        $('#contactSubmit').trigger('click');
      });


      //-------------------------------------------
      //Handle Members Area Toggle button
      //-------------------------------------------
      $('.menu-btn-members-login').click(function(e){
        e.preventDefault();
        e.stopPropagation();

        if ($('.new-header').hasClass('logged-in')) {
          window.location = '/members-area/';
        } else {
          if ($('#loginBox').length < 1) {
            // $('#loginToggle .loader, #loginToggleResp .loader').show();
            $.ajax({
              url: ajaxurl,
              data: {
                action: 'login_click'
              }
            }).done(function(response) {
              if (response !== '') {
                $('.body-wrapper').prepend(response);
                //Waiting for close button
                $('#loginBox .wrp #closeButton').click(function(){
                  $('#loginBox').removeClass('slide-in');
                });
                handleLoginClick();
                setTimeout(function() {
                  $('#loginBox').addClass('slide-in');
                },200);
              }
            }).always(function() {
              setTimeout(function() {
                // $('#loginToggle .loader, #loginToggleResp .loader').hide();
              },500);
            });
          } else {
            $('#loginBox').addClass('slide-in');
          }
        }
      });

      $('#loginBox .wrp #closeButton').click(function(){
        $('#loginBox').removeClass('slide-in');
      });


      //-------------------------------------------
      //Handle Back To Top button
      //-------------------------------------------
    	$('#backToTop').click(function(){
    		$('.body-wrapper').animate({scrollTop : 0},500);
    		return false;
    	});


      //-------------------------------------------
      //Handle Burger stack
      //-------------------------------------------
      $('.burger-btn').click(function() {
        $(this).toggleClass('opened');
        $('#mainHeader .col.one .brand img').toggleClass('hide-opacity');
        $('#responsive-wrapper').fadeToggle();
      });


      //-------------------------------------------
      //Init login click handler
      //-------------------------------------------
      handleLoginClick();

      if ($('.new-header').hasClass('logged-in')) {
        $('.menu-btn-members-login').each(function() {
          const $logoutBtn = $(this).clone();
          $logoutBtn.addClass('no-icon');
          $logoutBtn.insertAfter($(this));
          $logoutBtn.find('a').text('Logout');
          $logoutBtn.find('a').attr('href', $('.new-header').data('logout-url'));
        });
      }

   });

   $(window).load(function(){
      $('.initial-hidden').css('opacity',1);
   });

   $(window).resize(function() {
     setContentBlockPadding();
   });



  $('.burger-stack').on('click', function() {
  $(this).toggleClass('open');
  $('.header-inner-responsive').toggleClass('open');
  });

  //  Remove unneeded items from footer
  if ($('#mainFooter .menu-btn').length > 0) {
    $('#mainFooter .menu-btn').remove();
  }

  // Video section
  if ($('.ns-video-section').length > 0) {
    $('.ns-video-section .video-wrap .video-splash').on('click', function() {
      $(this).hide();
      $(this).siblings('.video-item').get()[0].play();
    });

    $('.ns-video-section .video-wrap .video-item').on('ended', function() {
      $(this).siblings('.video-splash').show();
    });
  }

  // FAQ section
  if ($('.ns-frequently-asked-questions-section').length > 0) {
    $('.ns-frequently-asked-questions-section .question-header').on('click', function() {
      // Close all others
      $this_ = $(this);

      $('.ns-frequently-asked-questions-section .question-header').each(function() {
        if ($(this).get()[0] != $this_.get()[0]) {
          $(this).parent().removeClass('show');
          $(this).siblings('.question-content').stop().slideUp(200);
        }
      });

      $(this).siblings('.question-content').stop().slideToggle(200);
      $(this).parent().toggleClass('show');
    });
  }

  // Contact template, move all fields to their bootstrap columns
  if ($('.ns-contact-wrap').length > 0) {
    function moveContactFields() {
      $('.field-c-reason').detach().appendTo('#col-reason');
      $('.field-c-name').detach().appendTo('#col-name');
      $('.field-c-job').detach().appendTo('#col-job');
      $('.field-c-email').detach().appendTo('#col-email');
      $('.field-c-school').detach().appendTo('#col-school');
      $('.field-c-message').detach().appendTo('#col-message');
    }

    moveContactFields();

    // Look for any error messages
    if ($('.validation_message').length > 0) {
      $('.validation_message').each(function() {
        const message = $(this).html();

        $(this).siblings('.gfield_label').find('.gfield_required').addClass('show');
        $(this).siblings('.gfield_label').find('.gfield_required').find('.gfield_required_text').html(message);
      });
    }
  }

  // Global popup
  if ($('.global-popup').length > 0) {
    function closePopup() {
      // Add a cookie so we don't see it again.
      const expDate = new Date();
      expDate.setDate(expDate.getDate() + 7);

      const expires = expDate.toUTCString();

      document.cookie = "popup_seen=true;expires="+expires+";path=/";

      $('.global-popup').addClass('closed');
    }

    $('.popup-close-btn').on('click', function() {
      closePopup();
    });

    $('.popup-cta-btn').on('click', function() {
      closePopup();
    });

    $('.global-popup').on('click', function(e) {
      if (e.target.classList.contains('global-popup')) {
        closePopup();
      }
    });
  }

  // Banner video popup
  if ($('.cta-video-player').length > 0) {
    $('.cta-video-player').each(function() {
      $(this).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const i = $(this).data('index');

        $('#video-popup-' + i).addClass('open');
        $('#video-popup-' + i).find('.video-popup-inner-item').get()[0].play();
      });
    });
  }

  $('.video-popup').on('click', function(e) {
    if (e.target.classList.contains('video-popup')) {
      $(this).find('.video-popup-inner-item').get()[0].pause();
      $(this).removeClass('open');
    }
  });

  $('.video-popup-close').on('click', function() {
    $(this).parent().siblings('.video-popup-inner').find('.video-popup-inner-item').get()[0].pause();
    $(this).parent().parent().parent().removeClass('open');
  });

})(jQuery); // Fully reference jQuery after this point.
